import { createFileRoute } from '@tanstack/react-router'

import { StateSwitcher } from '@/components/atoms/state-switcher'
import { SubscriptionBanner } from '@/components/molecules/subscription-banner'
import HomeHeader from '@/components/organisms/home/home-header'
import QuickChatInput from '@/components/organisms/home/quick-chat-input'
import StaleBanner from '@/components/organisms/home/stale-banner'
import VideoLibrary from '@/components/organisms/home/video-library'
import { useIndividuals } from '@/hooks/useIndividuals'

const HomePage = () => {
  const { individualQuery, selectedIndividual } = useIndividuals()

  return (
    <StateSwitcher isLoading={individualQuery.isLoading && !selectedIndividual}>
      {selectedIndividual && <HomeContent />}
    </StateSwitcher>
  )
}

const HomeContent = () => {
  return (
    <div className="max-w-6xl">
      <div>
        <HomeHeader />
        <div className="mt-8">
          <SubscriptionBanner />
        </div>
        <div className="mt-12 flex justify-center">
          <StaleBanner />
        </div>
        <div className="mt-12 py-4">
          <QuickChatInput />
        </div>
        <div className="mt-28">
          <VideoLibrary />
        </div>
      </div>
    </div>
  )
}

export const Route = createFileRoute('/_authenticated/home')({
  component: HomePage,
})
